import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number, preserveExtension = false): string {
    if (!value) return '';
    if (value.length <= limit) return value;

    if (preserveExtension && value.includes('.')) {
      const lastDotIndex = value.lastIndexOf('.');
      const extension = value.substring(lastDotIndex);
      const name = value.substring(0, lastDotIndex);
      const nameLimit = Math.max(0, limit - extension.length - 4); // 4 for '... '
      return name.substring(0, nameLimit) + '... ' + extension;
    }

    return value.substring(0, limit) + '...';
  }
}
